import React, { useEffect, useState } from 'react'
import {Grid, Box, Paper, Typography, Container, Button, Stack, Avatar, 
    Select, MenuItem,
    RadioGroup, FormControl, FormLabel, FormControlLabel, Radio,
    TextField, 
    TableRow, TableCell
} from '@mui/material'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { List, ListItem, ListItemText, ListItemButton, CircularProgress } from '@mui/material';
import Api from '../Services/Api';
import StaticVar from '../Config/StaticVar';
import Dialog from '../Components/Dialog'
import DataTable from '../Components/DataTable'
import QRCode from 'react-qr-code';
import { set } from 'lodash';

const QRCodeGenerator = ({text, name}) => {
  return (
    <div style={{ padding: 2, background: 'white', width: 'fit-content' }}>
      <QRCode value={text || 'Teks kosong'} />
      <Typography>{name}</Typography>
    </div>
  );
};

export default function AuthPage() {
    const [eventList, setEventList] = useState([])
    const [chooseEventYear, setChooseEventYear] = useState("0")
    const [chooseEventSemester, setChooseEventSemester] = useState("0")
    const [evaluatorList, setEvaluatorList] = useState([])
    const [textQR, setTextQR] = useState("")
    const [nameQR, setNameQR] = useState("")
    const [encoded, setEncoded] = useState("")
    const getEventList = async(year, semester)=>{
        const response = await Api.getAuthEvent({params:{year, semester, token: pageStatus.token}})
        setEventList(response)
    }

    const params = new URLSearchParams(window.location.search);
    const passcode = params.get('passcode');

    const [pageStatus, setPageStatus] = useState({})
    const checkAuth = async() =>{
        const response = await Api.postAuth({passcode})
        setPageStatus(response)
    }
    useEffect(()=>{
        checkAuth()
    },[])

    const [openModalEvaluator, setOpenModalEvaluator] = useState(false)
    const handleOpenEvaluator = async(item)=>{
        setOpenModalEvaluator(true)
        const response = await Api.getAuthEvaluator(item.EVENT_ID, {params: {token: pageStatus.token}})
        setEvaluatorList(response)
    }
    const handleCloseEvaluator = ()=>{
        setOpenModalEvaluator(false)
    }

    const [openModalQR, setOpenModalQR] = useState(false)
    const handleOpenQR = async(item)=>{
        setOpenModalQR(true)
        setTextQR(item.text)
        setNameQR(item.name)
    }
    const handleCloseQR = ()=>{
        setOpenModalQR(false)
    }


  return (
    <Container maxWidth="xl"  sx={{p:1}}>
        
        <Dialog fullWidth={true}
            maxWidth={"sm"}
            open={openModalQR} 
            title="Access Code" 
            handleClickOpen={handleOpenQR}
            handleClose={handleCloseQR}>
            <center>
                <Typography variant='p'>Silahlakan Scan QR Code ini pada menu penguji ujian <br/> untuk mengaktifkan halaman penilaian</Typography>
                {QRCodeGenerator({text:textQR, name: nameQR})}
                {/* <Typography variant='caption'>{textQR}</Typography> */}
                <Typography variant='h6'>Access Code : {encoded}
                </Typography>
            </center>
        </Dialog>
        <Dialog 
            title="Evaluator Access" 
            maxWidth={"md"}
            fullWidth={true}
            open={openModalEvaluator} 
            handleClickOpen={handleOpenEvaluator}
            handleClose={handleCloseEvaluator}>
                <DataTable headers={[
                    {name : "NO", align:'center',width:10},
                    {name : "NAME", align:'left'},
                    {name : "QR CODE", align:'center', width:150},
                ]}> 
                    {evaluatorList.map((row, index) => (
                        <TableRow
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                        <TableCell align="center" component="th" scope="row">
                            {index+1}
                        </TableCell>
                        <TableCell component="th" scope="row">
                            {row.EVALUATOR_NAME}
                        </TableCell>
                        <TableCell align="center">
                            <Button variant='contained' color='primary' onClick={async()=>{
                                const response = await Api.postGenerate({str: row.EVENT_ID+'&'+row.EVALUATOR_ID, name: row.EVALUATOR_NAME, token: pageStatus.token})
                                handleOpenQR({text: row.EVENT_ID+'&'+row.EVALUATOR_ID, name: row.EVALUATOR_NAME})
                                setEncoded(response)
                            }}>View</Button>
                        </TableCell>
                        </TableRow>
                    ))}
                </DataTable>
        </Dialog>
        <Paper elevation={3} sx={{p:2}}>
            <Typography variant='h5'>Authentication Page</Typography>
            <Typography variant='caption'>Passcode : ***** | Status : {pageStatus?.msg || "" } </Typography>
            <br/>
            {pageStatus?.token && <Typography variant='caption'>Token : {pageStatus.token}</Typography> }
            
            {pageStatus.status && <>
            
            <Stack direction="row" 
                spacing={2}
                sx={{
                    mt:2,
                    mb:2,
                    justifyContent: "flex-start",
                    alignItems: "center",
                }}>
                    <Typography>Filter By  : </Typography>
                    <Select value={chooseEventYear} onChange={e=>{
                        if(e.target.value !== "0" && chooseEventSemester !=="0"){
                            getEventList(e.target.value, chooseEventSemester)
                        }
                        setChooseEventYear(e.target.value)
                    }}>
                        <MenuItem value="0">Tahun</MenuItem>
                        {
                            Array.from({ length: 10 }, (_, i) => (new Date().getFullYear()) - i).map(item=>(<MenuItem value={item}>{item}</MenuItem>))
                        }
                    </Select>
                    <Select value={chooseEventSemester} onChange={e=>{
                        if(e.target.value !== "0" && chooseEventYear !=="0"){
                            getEventList(chooseEventYear, e.target.value)
                        }
                        setChooseEventSemester(e.target.value)
                    }}>
                        <MenuItem value="0">Semester</MenuItem>
                        <MenuItem value="I (SATU)">I (SATU)</MenuItem>
                        <MenuItem value="II (DUA)">II (DUA)</MenuItem>
                    </Select>
            </Stack>
            <DataTable headers={[
                {name : "NO", align:'center',width:10},
                {name : "EVENT NAME", align:'left'},
                {name : "YEAR", align:'center', width:100},
                {name : "SEMESTER", align:'center', width:80},
                {name : "STATUS", align:'center', width:80},
                {name : "AUTH PANEL", align:'center', width:180},
            ]}> 
                {eventList && eventList.map((row, index) => (
                    <TableRow
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                    <TableCell align="center" component="th" scope="row">
                        {index+1}
                    </TableCell>
                    <TableCell component="th" scope="row">
                        {row.EVENT_NAME}
                    </TableCell>
                    <TableCell align="center">{row.YEAR_EVENT}</TableCell>
                    <TableCell align="center">{row.SEMESTER}</TableCell>
                    <TableCell align="center">{row.STATUS === 0 ? "Close" : "Open"}</TableCell>
                    <TableCell align="center">
                        <Button variant='contained' color='primary' onClick={()=>handleOpenEvaluator(row)}>Open Data</Button>
                    </TableCell>
                    </TableRow>
                ))}
            </DataTable>
            </>}
        </Paper>
    </Container>
  )
}
